<template>
  <div style="width: 100%" class="fill-height">
    <v-btn
      style="z-index: 4"
      rounded
      fixed
      bottom
      right
      color="primary"
      @click="openAddOrgUnit"
      v-if="$vuetify.breakpoint.smAndDown"
    >
      <v-icon>mdi-plus</v-icon>
      <span>{{ $t(`$vuetify.company.addOrgUnitBtn`) }}</span>
    </v-btn>
    <v-container>
      <v-row class="d-flex justify-end pt-3 pb-1 pr-3">
        <v-btn class="orgunit-add-btn" elevation="0" @click="openAddOrgUnit">
          <v-icon left small>mdi-plus</v-icon>
          Dodaj ustrojstvenu jedinicu
        </v-btn>
      </v-row>
      <v-row style="margin-top: 16px" class="d-flex justify-center">
        <v-col cols="12" sm="11" lg="11" :class="['px-0']">
          <v-card v-for="(orgUnit, i) in orgUnits" :key="i" flat class="orgunit-card pb-2 mb-2">
            <v-row class="ma-0 pa-0">
              <v-col
                cols="4"
                sm="4"
                md="2"
                lg="2"
                xl="2"
                :class="[densityPadding]"
              >
                <div class="caption grey--text text-center">
                  Ime ustrojstvene jedinice
                </div>
                <div class="text-center">{{ orgUnit.name }}</div>
              </v-col>
              <v-col
                cols="4"
                sm="4"
                md="2"
                lg="2"
                xl="2"
                style="min-width: 100px; max-width: 100%"
                :class="[densityPadding, 'flex-grow-1', 'flex-shrink-0']"
              >
                <div class="caption grey--text text-center">Printer</div>
                <div class="text-capitalize text-center">
                  {{ orgUnit.printerName }}
                </div>
              </v-col>
              <v-col
                cols="4"
                sm="4"
                md="2"
                lg="2"
                xl="2"
                style="min-width: 100px; max-width: 100%"
                :class="[densityPadding, 'flex-grow-1', 'flex-shrink-0']"
              >
                <div class="d-flex justify-end align-center pl-2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mt-0 pt-0"
                        :x-small="density === 'greater'"
                        v-on="on"
                        v-bind="attrs"
                        icon
                        @click="openEditOrgUnit(orgUnit)"
                        @keypress.enter="openEditOrgUnit(orgUnit)"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Uredi ustrojstvenu jedinicu</span>
                  </v-tooltip>
                </div></v-col
              >
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <infinite-loading
        ref="InfiniteLoading"
        @infinite="infiniteHandler"
        spinner="waveDots"
      >
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
      <add-organizational-unit-inline
        v-if="showAddOrgUnit"
        :location="location"
        :company="company"
        @close="showAddOrgUnit = false"
      ></add-organizational-unit-inline>
      <edit-organizational-unit-inline
        v-if="showEditOrgUnit"
        :location="location"
        :company="company"
        :org-unit="orgUnitToEdit"
        @close="showEditOrgUnit = false"
      ></edit-organizational-unit-inline>
    </v-container>
  </div>
</template>
<script>
import AddOrganizationalUnitInline from '@/modules/point-of-sale/components/organizational-unit-configuration/AddOrganizationalUnitInline'
import EditOrganizationalUnitInline from '@/modules/point-of-sale/components/organizational-unit-configuration/EditOrganizationalUnitInline'
import { df } from '@/plugins/firebase'
import { clone } from '@/plugins/utils'
import InfiniteLoading from 'vue-infinite-loading'
import applicationSettings from '@/mixins/applicationSettings'

export default {
  name: 'OrganizationUnitConfigurationInline',
  mixins: [applicationSettings],
  components: { AddOrganizationalUnitInline, InfiniteLoading, EditOrganizationalUnitInline },
  props: {
    location: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    orgUnits: [],
    orgUnitsSorted: [],
    printers: [],
    listeners: [],
    showAddOrgUnit: false,
    showEditOrgUnit: false,
    orgUnitToEdit: null
  }),
  computed: {

  },
  watch: {

  },
  mounted () {
    const query = df
      .collection(`location_printers/${this.location.id}/printers`)
    const listener = query
      .onSnapshot((doc) => {
        doc.docs.forEach((rec) => {
          this.printers.push(rec.data())
        })
      }
      )
    this.listeners.push(listener)
  },
  beforeDestroy () {
    this.detachListeners()
  },
  methods: {
    openAddOrgUnit () {
      this.showAddOrgUnit = true
    },
    openEditOrgUnit (orgUnit) {
      this.orgUnitToEdit = orgUnit
      this.showEditOrgUnit = true
    },
    modifyOrgUnits (changedOrgUnit) {
      if (changedOrgUnit.printer && changedOrgUnit.printer !== '') {
        this.printers.forEach(printer => {
          if (printer.id === changedOrgUnit.printer) {
            changedOrgUnit.printerName = printer.name
          }
        })
      }
      let found = false
      this.orgUnits.forEach((orgUnit, key) => {
        if (orgUnit.id === changedOrgUnit.id) {
          found = true
          this.orgUnits[key] = changedOrgUnit
        }
      })

      if (!found) {
        this.orgUnits.push(changedOrgUnit)
      }

      this.orgUnitsSorted = clone(this.orgUnits.sort((a, b) => a.name.localeCompare(b.name)))
    },
    infiniteHandler ($state) {
      if (this.location.id !== '') {
        const query = df.collection(`location_units/${this.location.id}/units`)
        const listener = query
          .onSnapshot((doc) => {
            doc.docs.forEach((rec) => {
              this.modifyOrgUnits(rec.data())
            })
            $state.complete()
          })
        this.listeners.push(listener)
      } else {
        $state.complete()
      }
    }
  }
}
</script>
<style scoped>
.orgunit-add-btn {
  background: rgba(0, 188, 212, 0.08) !important;
  color: #00838F !important;
  border: 1.2px solid #00b3be !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px !important;
  padding: 0 16px !important;
  height: 40px !important;
  min-height: 40px !important;
  white-space: nowrap;
}
.orgunit-add-btn:hover {
  background: rgba(0, 179, 190, 0.12) !important;
  box-shadow: none !important;
}
.orgunit-add-btn .v-icon {
  color: #00BCD4 !important;
  font-size: 17px !important;
}
.orgunit-card {
  background: #F8FAFC !important;
  border: 1px solid #E2E8F0 !important;
  border-radius: 10px !important;
}
</style>
